module.exports = __webpack_public_path__ + "static/media/r-telecom_logo.9f9d5c9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/r-telecom_logo.png
// module id = 922
// module chunks = 0